<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <!-- Filter section -->
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDate"
                      label="Từ ngày"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="startDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              
              <v-col cols="12" md="4">
                <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      label="Đến ngày"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="endDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="customerName"
                  label="Tên khách hàng"
                  prepend-icon="person"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="filterData" :loading="loading">
                  <v-icon left>search</v-icon>
                  Tìm kiếm
                </v-btn>
                <v-btn color="success" @click="exportExcel" :loading="loading" class="ml-2">
                  <v-icon left>get_app</v-icon>
                  Xuất Excel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          
          <!-- Summary cards -->
          <v-card-text v-if="totals && totals.TotalCustomers">
            <v-row>
              <v-col cols="12" md="3">
                <v-card color="primary" dark>
                  <v-card-text>
                    <div class="text-h6">Tổng khách hàng</div>
                    <div class="text-h4">{{ totals.TotalCustomers | currency }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card color="info" dark>
                  <v-card-text>
                    <div class="text-h6">Tổng phiếu xuất</div>
                    <div class="text-h4">{{ totals.TotalBills | currency }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card color="success" dark>
                  <v-card-text>
                    <div class="text-h6">Tổng tiền</div>
                    <div class="text-h4">{{ totals.GrandTotalAmount | currency }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card color="error" dark>
                  <v-card-text>
                    <div class="text-h6">Tổng công nợ</div>
                    <div class="text-h4">{{ totals.GrandTotalDebt | currency }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          
          <!-- Data table -->
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :loading="loading"
            :mobile-breakpoint="100"
            show-expand
            :expanded.sync="expanded"
            item-key="CustomerID"
            @item-expanded="onItemExpanded"
            class="elevation-1"
            fixed-header
            height="calc(100vh - 350px)"
          >
            <template v-slot:item.CustomerName="{ item }">
              <strong>{{ item.CustomerName }}</strong>
            </template>
            
            <template v-slot:item.TotalCodes="{ item }">
              <span>{{ item.TotalCodes | currency }}</span>
            </template>
            
            <template v-slot:item.TotalPacks="{ item }">
              <span>{{ item.TotalPacks | currency }}</span>
            </template>
            
            <template v-slot:item.TotalWeight="{ item }">
              <span>{{ item.TotalWeight | currency('', 1) }}</span>
            </template>
            
            <template v-slot:item.TotalVolume="{ item }">
              <span>{{ item.TotalVolume | currency('', 2) }}</span>
            </template>
            
            <template v-slot:item.TotalAmount="{ item }">
              <span>{{ item.TotalAmount | currency }}</span>
            </template>
            
            <template v-slot:item.TotalPaid="{ item }">
              <span class="green--text">{{ item.TotalPaid | currency }}</span>
            </template>
            
            <template v-slot:item.TotalDebt="{ item }">
              <span class="red--text font-weight-bold">{{ item.TotalDebt | currency }}</span>
            </template>
            
            <template v-slot:item.TotalBills="{ item }">
              <v-chip small color="primary">{{ item.TotalBills }}</v-chip>
            </template>
            
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-4 grey lighten-4">
                <v-card flat v-if="billsMap[item.CustomerID] && billsMap[item.CustomerID].length > 0">
                  <v-card-title class="subtitle-1 py-2 font-weight-bold">Danh sách phiếu xuất đang có công nợ</v-card-title>
                  <v-data-table
                    :headers="billHeaders"
                    :items="billsMap[item.CustomerID]"
                    hide-default-footer
                    disable-pagination
                    class="elevation-0 mb-2"
                  >
                    <template v-slot:item.BillCode="{ item }">
                      <router-link :to="{ name: 'BillDetail', params: { Pid: item.ID } }" target="_blank">
                        {{ item.BillCode }}
                      </router-link>
                    </template>
                    <template v-slot:item.ExportDate="{ item }">
                      {{ item.ExportDate | moment("DD/MM/YYYY HH:mm") }}
                    </template>
                    <template v-slot:item.Weight="{ item }">
                      {{ item.Weight | currency('', 1) }}
                    </template>
                    <template v-slot:item.Volume="{ item }">
                      {{ item.Volume | currency('', 2) }}
                    </template>
                    <template v-slot:item.LineAmount="{ item }">
                      {{ item.LineAmount | currency }}
                    </template>
                    <template v-slot:item.PaidAmount="{ item }">
                      <span class="green--text">{{ item.PaidAmount | currency }}</span>
                    </template>
                    <template v-slot:item.Debt="{ item }">
                      <span class="red--text font-weight-bold">{{ item.Debt | currency }}</span>
                    </template>
                  </v-data-table>
                </v-card>
                <div v-else class="text-center py-4 text--secondary">
                  Không có chi tiết phiếu xuất
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";

export default {
  data() {
    return {
      startDate: moment().startOf('year').format('YYYY-MM-DD'),
      endDate: moment().endOf('year').format('YYYY-MM-DD'),
      startDateMenu: false,
      endDateMenu: false,
      customerName: "",
      expanded: [],
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      billHeaders: [
        { text: "Mã phiếu", value: "BillCode", align: "start" },
        { text: "Ngày xuất", value: "ExportDate", align: "center" },
        { text: "Mã hàng", value: "NumberOfCode", align: "end" },
        { text: "Kiện", value: "NumberOfPack", align: "end" },
        { text: "Cân nặng (kg)", value: "Weight", align: "end" },
        { text: "Khối (m³)", value: "Volume", align: "end" },
        { text: "Tổng tiền", value: "LineAmount", align: "end" },
        { text: "Đã thanh toán", value: "PaidAmount", align: "end" },
        { text: "Công nợ", value: "Debt", align: "end" },
      ],
      headers: [
        {
          text: "Mã KH",
          value: "CustomerID",
          align: "start"
        },
        {
          text: "Tên khách hàng",
          value: "CustomerName",
          align: "start"
        },
        {
          text: "Số phiếu",
          value: "TotalBills",
          align: "center"
        },
        {
          text: "Tổng mã hàng",
          value: "TotalCodes",
          align: "end"
        },
        {
          text: "Tổng kiện",
          value: "TotalPacks",
          align: "end"
        },
        {
          text: "Tổng cân nặng (kg)",
          value: "TotalWeight",
          align: "end"
        },
        {
          text: "Tổng khối (m³)",
          value: "TotalVolume",
          align: "end"
        },
        {
          text: "Tổng tiền (VNĐ)",
          value: "TotalAmount",
          align: "end"
        },
        {
          text: "Đã thanh toán (VNĐ)",
          value: "TotalPaid",
          align: "end"
        },
        {
          text: "Công nợ (VNĐ)",
          value: "TotalDebt",
          align: "end"
        }
      ]
    };
  },
  watch: {
    pagination: {
      handler: function() {
        this.filterData();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.customerDebt.all.data,
      total_rows: state => state.customerDebt.all.total,
      totals: state => state.customerDebt.all.totals,
      loading: state => state.customerDebt.loading,
      billsMap: state => state.customerDebt.bills
    })
  },
  methods: {
    filterData() {
      const param = {
        pagination: this.pagination,
        startTime: this.startDate + ' 00:00:00',
        endTime: this.endDate + ' 23:59:59',
        customerName: this.customerName || null
      };
      this.$store.dispatch("customerDebt/getList", param);
    },
    
    onItemExpanded({ item, value }) {
      if (value && !this.billsMap[item.CustomerID]) {
        this.$store.dispatch("customerDebt/getBills", {
          customerID: item.CustomerID,
          startTime: this.startDate + ' 00:00:00',
          endTime: this.endDate + ' 23:59:59'
        });
      }
    },

    exportExcel() {
      const param = {
        startTime: this.startDate + ' 00:00:00',
        endTime: this.endDate + ' 23:59:59',
        customerName: this.customerName || null
      };
      this.$store.dispatch("customerDebt/exportList", param);
    }
  },
  mounted() {
    this.filterData();
  }
};
</script>

<style scoped>
.text-h4 {
  margin-top: 8px;
}
</style>
